// extracted by mini-css-extract-plugin
module.exports = {"savedText":"_3hgSII","icon":"_1BLXKe","checked":"_22NNPs","unchecked":"_14Mw6W","isChecked":"_2m7YvR","icon-hide":"_1RwIiw","icon-show":"_22b2fy","compact":"_2WdD9y"};